import React, { useState, useCallback, useEffect } from 'react';
import { Row, Col, Select, Tag, Tooltip } from 'antd';
import { debounce } from 'lodash'
// import ChartLoadingIcon from "../../../../../assets/icons/chart-loading.png";
import CustomIcon from '../../../../../utils/components/CustomIcon/CustomIcon';

import './SearchSymptoms.css'

const Tags = ({ selections, setSelections, handleClose }) => {
  return (
    <div id="symptom-tag-container" className="flex-horizontal-gap-1" style={{ flexWrap: 'wrap', gap: '4px' }}>
      {
        selections.map((selection, index) => {
          if (selection.type === 'logic') {
            return (
              <Select className="tag-selection" size="small" value={selection.value} onChange={(val) => {
                const selectionsCopy = [...selections]
                // modify current index
                selectionsCopy[index].value = val
                setSelections(selectionsCopy)
              }}>
                <Select.Option value="AND">AND</Select.Option>
                {/* <Select.Option value="OR">OR</Select.Option> */}
              </Select>
            )
          }
          return <Tag
            className="symptom-tag"
            // style={{ borderRadius: '24px', margin: 0 }}
            closable={selection.type === 'term'}
            onClose={(e) => {
              e.preventDefault();
              handleClose(index);
            }}
          >
            {selection.value}
          </Tag>
        })
      }
    </div>
  )
}

const SearchSymptoms = ({ options, selections, setSelections }) => {

  const [loading, setLoading] = useState(true);
  const [logic, setLogic] = useState('AND'); // Track selected logic(AND|OR)
  const [selectedValue, setSelectedValue] = useState(null);
  const [filteredOptions, setFilteredOptions] = useState([]);

  // show loader until options are available
  useEffect(() => {
    if (options && options.length > 0) setLoading(false)
  }, [options])

  // Fetch options, ensuring it always gets the latest `options`
  const fetchOptions = useCallback(
    (value) => {
      if (!value) {
        setFilteredOptions([]);
        return;
      }
      setLoading(true);
      setTimeout(() => {
        const filtered = options.filter((item) => item.text.toLowerCase().includes(value.toLowerCase())).sort((a, b) => {
          const lowerQuery = value.toLowerCase();
          const lowerA = a.text.toLowerCase();
          const lowerB = b.text.toLowerCase();
    
          const isExactA = lowerA === lowerQuery;
          const isExactB = lowerB === lowerQuery;
    
          if (isExactA && !isExactB) return -1; // Exact match first
          if (!isExactA && isExactB) return 1;  
          return lowerA.indexOf(lowerQuery) - lowerB.indexOf(lowerQuery); // Sort by index of match
        }).slice(0, 100); // Keep only first 100 results;
        setLoading(false);
        setFilteredOptions(filtered); // Limit results for performance
      }, 600);
    },
    [options] // Ensures fetchOptions updates when `options` changes
  );

  // Debounce the fetchOptions function
  const debouncedSearch = useCallback(debounce(fetchOptions, 600), [fetchOptions]);

  // Cleanup debounce on unmount
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleSelect = (value) => {
    const term = value.split('__')[1]
    console.log('--------', value)
    setSelectedValue(value)
    setSelections((prevValue) => {
      if (prevValue.length === 0) return [{ value: term, type: 'term' }]
      return [...prevValue, { value: logic, type: 'logic' }, { value: term, type: 'term' }]
    })
  }

  const handleChange = (value) => {
    // clear input
    if (!value) {
      setSelectedValue(null)
      setFilteredOptions([])
    }
  }

  const handleTagClose = (index) => {
    setSelections((prevVal) => {
      // removing only element
      if (prevVal.length === 1) return []
      const newVal = [...prevVal]
      // removing first element
      if (index === 0) newVal.splice(index, 2);
      else newVal.splice(index - 1, 2); // Remove 2 elements starting from index-1
      return newVal
    })
  }

  return (
    <div className="flex-vertical-gap-2">
      {/* <Row gutter={8}>
        <Col span={24}> */}
          {selections.length > 0 && <Tags selections={selections} setSelections={setSelections} handleClose={handleTagClose} />}
        {/* </Col>
      </Row> */}
      {/* <Row gutter={8}> */}
        {/* <Col span={6}>
          <Select value={logic} onChange={(val) => setLogic(val)}>
            <Select.Option value="AND">AND</Select.Option>
            <Select.Option value="OR">OR</Select.Option>
          </Select>
        </Col> */}
        {/* <Col span={24}> */}
          <Select
            placeholder="Enter symptom"
            showSearch
            allowClear
            value={selectedValue}
            onSelect={handleSelect}
            onSearch={debouncedSearch}
            onChange={handleChange}
            onBlur={() => setSelectedValue(null)}
            filterOption={false} // Disable default filtering, we handle it manually
            notFoundContent={loading ?
            <div className="flex-horizontal-gap-1"><CustomIcon name="ChartLoading" />Loading...</div> :
            <div className="flex-horizontal-gap-1"><CustomIcon name="Info" />No matching symptoms</div>
            }
          >
            {filteredOptions.map((option, index) => (
              <Select.Option key={`${index}__${option.text}`} value={`${index}__${option.text}`}>
                <Tooltip 
                placement="rightTop"
                // width='100%'
                // title={option.description} 
                mouseEnterDelay={0}  // Remove delay
                // getPopupContainer={(trigger) => trigger.parentElement} // Ensure visibility
                key={index} 
                title={option.hierarchy}
                >
                  <div>{option.text}</div>
                </Tooltip>
              </Select.Option>
            ))}
          </Select>
        {/* </Col> */}
      {/* </Row> */}
    </div>
  );
};

export default SearchSymptoms